export default __webpack_public_path__ + "_/images/knowledge-center/category-account-411df7658821f02ceb907d6effa302eb835bc898a21c2782a7b231768e8c96b9.png";